import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { apiClient } from "../lib/api";
import { toast } from "sonner";
import { LockKey } from "@phosphor-icons/react";
import { PasswordInput } from "../components/PasswordInput";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Passwords don't match"); return; }
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setLoading(true);
    try {
      await apiClient.post("/auth/reset-password", { token, password: pw });
      toast.success("Password updated — sign in with your new password");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not reset password");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-16 grid-bg">
        <div className="w-full max-w-md surface border border-white/10 p-8 text-center">
          <h1 className="font-heading text-3xl uppercase font-black">Invalid Link</h1>
          <p className="text-white/60 mt-3 text-sm">This reset link is missing its token.</p>
          <Link to="/forgot-password" className="mt-6 inline-block text-primary-yellow hover:underline">Request a new one</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-16 grid-bg">
      <div className="w-full max-w-md surface border border-white/10 p-8">
        <div className="text-[10px] uppercase tracking-[0.3em] text-primary-yellow font-bold">Reset Password</div>
        <h1 className="font-heading text-4xl uppercase font-black mt-2">Choose a new password</h1>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="reset-form">
          <Field label="New password">
            <PasswordInput
              testid="reset-password"
              required
              minLength={6}
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              autoComplete="new-password"
            />
          </Field>
          <Field label="Confirm new password">
            <PasswordInput
              testid="reset-password-confirm"
              required
              minLength={6}
              value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              autoComplete="new-password"
            />
          </Field>
          <button
            data-testid="reset-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-primary-yellow text-black font-bold uppercase tracking-[0.2em] py-4 text-sm hover:-translate-y-0.5 transition-transform disabled:opacity-50 flex items-center justify-center gap-2"
          >
            <LockKey size={14} weight="bold" />
            {loading ? "Saving…" : "Set new password"}
          </button>
        </form>
      </div>
    </div>
  );
}

const Field = ({ label, children }) => (
  <div>
    <label className="block text-[10px] uppercase tracking-[0.2em] text-white/50 mb-2 font-semibold">{label}</label>
    {children}
  </div>
);
